import get from 'lodash/get';

export const useImages = ({
  data,
  type,
  view,
}) => {
  const images = get(data, 'images');
  const links = get(data, 'contentModules')?.filter((module) => module.sys.contentType.sys.id === 'link')?.map((module) => module.fields?.url);

  return {
    type,
    view,
    images,
    links,
  };
};
